// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_5b02b8a","promotionInfo":"_d677bbd","promotionAmount":"_fcf984c","promotionExpiry":"_9ae4e13","radio":"_348ddc0","add":"_7c9a2a7"};